module.exports = __webpack_public_path__ + "static/media/GAB.399888b1.svg";